import { useState, useEffect, useRef } from 'react';

const useGlobalTyping = () => {
  const [text, setText] = useState('');
  const [dirty, setDirty] = useState(false);
  const hiddenInputRef = useRef(null);

  useEffect(() => {
    const handleInput = () => {
      // Capture the inner text of the hidden div and set it as text
      if (hiddenInputRef.current) {
        setText(hiddenInputRef.current.innerText.replaceAll(/\s/g,'').replaceAll("\n", "").replaceAll("\t", ""));
      }
    };

    const focusHiddenInput = () => {
      if (hiddenInputRef.current) {
        hiddenInputRef.current.focus();

        // Move cursor to the end of the text
        const range = document.createRange();
        const selection = window.getSelection();
        range.selectNodeContents(hiddenInputRef.current);
        range.collapse(false); // Set to end of content
        selection.removeAllRanges();
        selection.addRange(range);
      }
    };

    if (hiddenInputRef.current) {
      hiddenInputRef.current.addEventListener('input', handleInput);
    }
    document.addEventListener('click', focusHiddenInput);
    document.addEventListener('keydown', () => {
      setDirty(true);
      focusHiddenInput()
    });

    // Initial focus to start capturing input
    focusHiddenInput();

    return () => {
      if (hiddenInputRef.current) {
        hiddenInputRef.current.removeEventListener('input', handleInput);
      }
      document.removeEventListener('click', focusHiddenInput);
      document.removeEventListener('keydown', focusHiddenInput);
    };
  }, []);

  return { text, dirty, hiddenInputRef };
};

export default useGlobalTyping;